// extracted by mini-css-extract-plugin
export default {"notfound":"notfound_notfound__LmaYl","text":"notfound_text__mDxmH","btn":"notfound_btn__s1UvB","disabled":"notfound_disabled__MdAbD"};